import React from "react";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { row, stack } from "@ui/style";
import { physioMeMobileBreakpoint, physioMeTabletBreakpoint } from "@ui/style";
import { colors } from "@ui/style/colors";
import { Page } from "@ui/components/common/page";
import { PageHeader } from "@ui/components/common/page-header";
import { ExercisesCard } from "@ui/pages/get-started/components/exercises-card";
import { ProgramsCard } from "@ui/pages/get-started/components/programs-card";
import { PatientsCard } from "@ui/pages/get-started/components/patients-card";
import { css } from "@emotion/react";
export const GetStartedPage = (): JSX.Element => {
	const { format } = useI18n();

	return (
		<Page>
			<Container>
				<Header>
					<StyledPageHeader title={format("getStarted.title")} />
					<div className="p-size-m">{format("getStarted.description")}</div>
				</Header>
				<Body>
					<StyledExercisesCard />
					<DashedDivider />
					<StyledProgramsCard />
					<DashedDivider />
					<StyledPatientsCard />
				</Body>
			</Container>
		</Page>
	);
};

const Container = styled.div`
	padding-inline: 40px;

	@media ${physioMeTabletBreakpoint} {
		padding-inline: 5%;
	}

	@media ${physioMeMobileBreakpoint} {
		padding-inline: 20px;
	}
`;

const Header = styled.div`
	${stack("XS")};
	padding-block: 40px;

	@media ${physioMeMobileBreakpoint} {
		padding-block: 24px 16px;
	}
`;

const StyledPageHeader = styled(PageHeader)`
	padding: 0;

	@media ${physioMeMobileBreakpoint} {
		padding: 0;
	}
`;

const Body = styled.div`
	${row(undefined, undefined, "stretch")};

	@media ${physioMeTabletBreakpoint} {
		${stack(16, undefined, "center")};
	}
`;

const sharedCardStyles = css`
	@media ${physioMeTabletBreakpoint} {
		width: 100%;
	}
`;

const StyledExercisesCard = styled(ExercisesCard)`
	${sharedCardStyles}
`;

const StyledProgramsCard = styled(ProgramsCard)`
	${sharedCardStyles}
`;

const StyledPatientsCard = styled(PatientsCard)`
	${sharedCardStyles}
`;

const DashedDivider = styled.div<{ color?: string; dash?: number; gap?: number; height?: number }>`
	align-self: center;
	margin: 96px 5px 0 5px;
	width: 30px;
	height: ${({ height = 3 }) => height}px;
	background-image: ${({ color = colors.onboardingPrimary, dash = 7, gap = 5 }) =>
		`repeating-linear-gradient(to right, ${color} 0, ${color} ${dash}px, transparent ${dash}px, transparent ${dash + gap}px)`};

	@media ${physioMeTabletBreakpoint} {
		display: none;
	}
`;
